export default "__VITE_ASSET__FgO8iC0y__"